export const paths = {
  home: '/',
  aboutUs: '/about-us',
  meet: '/meet',
  changelog: '/platform-updates',
  publicOffer: '/public-offer',
  signIn: `/auth/sign-in`,
  signUp: `/auth/sign-up`,
  forgotPassword: `/auth/forgot-password`,
  validation: '/validation',
  dashboard: '/dashboard',
  /** Education profile (mentor/student) — `/{role}/profile`. */
  profile: '/profile',
  /** IAM account settings — `/{role}/account`. */
  account: '/account',
  webSite: '/web-site',
  blog: '/blog',
  support: '/support',
  wallet: '/wallet',
  walletFunding: '/wallet/funding',
  walletWithdraw: '/wallet/withdraw',
  mentors: '/mentors',
  search: '/search',
  lessons: '/lessons',
  lessonCreate: '/lessons/create',
  chat: '/chat',
  conversations: '/conversations',
  messages: '/messages',
  webBuilder: '/web-builder',
} as const;

export type PathKey = keyof typeof paths;
export type PathValue = (typeof paths)[PathKey];

export const ROLE_STORAGE_KEY = 'mentoring_role';

export const roles = {
  NONE: 'none',
  CLIENT: 'student',
  MENTOR: 'mentor',
} as const;

export type AppRole = (typeof roles)[keyof typeof roles];

/** Shared content pages — same URL for guest and authenticated shells. */
export const sharedPublicPaths = [
  paths.aboutUs,
  paths.meet,
  paths.changelog,
  paths.publicOffer,
] as const;

export function isSharedPublicPath(pathname: string): boolean {
  return sharedPublicPaths.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

export function lessonEditPath(offeringId: number): string {
  return `/lessons/${offeringId}/edit`;
}

export function mentorBookPath(slug: string): string {
  return `/mentors/${encodeURIComponent(slug)}`;
}

export function conversationPath(id?: number): string {
  if (id == null) return paths.conversations;
  return `${paths.conversations}/${id}`;
}

export function rolePath(role: AppRole | string, pagePath: string): string {
  if (!role || role === roles.NONE) return pagePath;
  if (sharedPublicPaths.includes(pagePath as (typeof sharedPublicPaths)[number])) {
    return pagePath;
  }
  if (pagePath === '/') return `/${role}`;
  return `/${role}${pagePath}`;
}

export const defaultRoutesByRole: Record<AppRole, string> = {
  none: paths.signIn,
  student: rolePath(roles.CLIENT, paths.dashboard),
  mentor: rolePath(roles.MENTOR, paths.dashboard),
};
